let wxScriptPromise = null;

export const loadWxLoginScript = () => {
  if (typeof window !== 'undefined' && typeof window.WxLogin === 'function') {
    return Promise.resolve();
  }

  if (wxScriptPromise) return wxScriptPromise;

  wxScriptPromise = new Promise((resolve, reject) => {
    const existingScript = Array.from(document.scripts || []).find((s) => {
      const src = String(s?.src || '');
      return src.includes('wxLogin.js') || src.includes('res.wx.qq.com/connect');
    });

    const waitForWxLogin = (timeoutMs = 6000) => {
      let elapsed = 0;
      const timer = setInterval(() => {
        elapsed += 100;
        if (typeof window.WxLogin === 'function') {
          clearInterval(timer);
          resolve();
        } else if (elapsed >= timeoutMs) {
          clearInterval(timer);
          reject(new Error('WxLogin script load timeout'));
        }
      }, 100);
    };

    if (existingScript) {
      waitForWxLogin();
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
    script.async = true;
    script.onload = () => {
      if (typeof window.WxLogin === 'function') resolve();
      else reject(new Error('WxLogin not available after script load'));
    };
    script.onerror = () => reject(new Error('Failed to load WxLogin script'));
    document.head.appendChild(script);
  });

  return wxScriptPromise;
};

export const renderWxLogin = async ({
  containerId,
  appid,
  scope,
  redirectUri,
  state,
  fastLogin = 0,
  styleLite = 0,
  href,
}) => {
  await loadWxLoginScript();

  const mountEl = document.getElementById(containerId);
  if (mountEl) mountEl.innerHTML = '';

  const defaultHref =
    typeof window !== 'undefined' && window.location?.protocol === 'https:'
      ? `${window.location.origin}/wxlogin.css`
      : '';
  const resolvedHref = href || defaultHref || '';

  return new window.WxLogin({
    self_redirect: false,
    id: containerId,
    appid,
    scope,
    redirect_uri: window.encodeURIComponent(redirectUri),
    state,
    style: '',
    href: resolvedHref ? window.encodeURIComponent(resolvedHref) : '',
    stylelite: styleLite ? 1 : 0,
    fast_login: fastLogin ? 1 : 0,
  });
};
